import { gql } from '@apollo/client';

export * from './continuityEscrowAgreementTerms.query.generated';

export const CONTINUITY_ESCROW_AGREEMENT_TERMS = gql`
  query continuityEscrowAgreementTerms($continuityEscrowId: ID!) {
    continuityEscrowTerms: continuityEscrow(continuityEscrowId: $continuityEscrowId) {
      agreement {
        terms
        termsDownloadPdfUrl
        termsSignedDownloadPdfUrl
        termsDownloadDocxUrl
      }
    }
  }
`;
